import React, { useState } from "react";
import Select from "react-select";
import styles from "../css/styles.module.css";

export default function AddReport(props) {
  const [report, setReport] = useState(() => {
    return {
      customer: "",
      detail: "",
      date: "",
      department: "",
      responsible: "",
      qtNumber: "",
    };
  });

  //react select component styling
  const selectStyle = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused
        ? "3px solid #C5C5C5 !important"
        : "3px solid lightskyblue !important",
      boxShadow: "none",
      borderRadius: "8px",
      fontSize: "1rem",
      width: "375px",
      margin: "10px auto",
    }),
    option: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "#C5C5C5",
      },
      backgroundColor: state.isFocused ? "lightskyblue" : "white",
      color: state.isSelected && "black",
      fontSize: "1rem",
    }),
  };

  //handle text change for input field
  function handleChange(e) {
    setReport({
      ...report,
      [e.target.name]: e.target.value,
    });
  }

  //handle dropdow select change
  function handleSelectChange(selected, actionMeta) {
    setReport({
      ...report,
      [actionMeta.name]: selected.label,
    });
  }

  return (
    <div className={styles.form2}>
      <form
        className={styles.gridForm}
        onSubmit={(e) => {
          props.handleAddSubmit(e, report);
        }}
      >
        <h1 className={styles.gridFormMerge}>Add Report</h1>
        <Select
          name="customer"
          styles={selectStyle}
          isSearchable
          placeholder="Customer"
          options={props.customer}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          className={styles.noMargin}
          type="date"
          name="date"
          onChange={handleChange}
          value={report.date}
          required
        />
        <Select
          name="contact"
          styles={selectStyle}
          isSearchable
          placeholder="Contact"
          options={props.contact}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          className={styles.noMargin}
          type="text"
          name="responsible"
          placeholder="Person Responsible"
          onChange={handleChange}
          value={report.responsible}
          required
        />
        <Select
          name="department"
          styles={selectStyle}
          isSearchable
          placeholder="Department"
          options={props.departments}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          type="text"
          name="qtNumber"
          placeholder="QT Number"
          onChange={handleChange}
          value={report.qtNumber}
        />
        <textarea
          className={styles.gridFormMerge}
          type="text"
          rows="4"
          name="detail"
          placeholder="Detail"
          onChange={handleChange}
          value={report.detail}
          required
        />
        <button className={styles.gridFormMerge} type="submit">
          Add
        </button>
      </form>
      <button
        type="button"
        className={styles.cancelButton}
        onClick={() => props.handleCancelClick()}
      >
        Cancel
      </button>
    </div>
  );
}
